import { SessionData } from '@/services/Statistic/SessionData'
import statisticApiClient from '@/services/Statistic/StatisticApiClient'
import {
  BrowseCategoryEventData,
  CorrectEventData,
  ExitEventData,
  ExitWithCategoryEventData,
  ExitWithProductEventData
} from '@/services/Statistic/PostData'

export class StatisticService {
  public sessionData: SessionData = new SessionData()

  createNewSession () {
    this.sessionData = new SessionData()

    let res = statisticApiClient.createSession()

    res.then((data: any) => {
      this.sessionData.id = data.id
    })

    return res
  }

  correctEvent (data: CorrectEventData) {
    data.sessionId = this.sessionData.id
    statisticApiClient.correctEvent(data)
  }

  synonymsDictUsageEvent () {
    let data: any = {}
    data.sessionId = this.sessionData.id
    statisticApiClient.synonymsDictUsageEvent(data)
  }

  browseCategoryEvent (data: BrowseCategoryEventData) {
    data.sessionId = this.sessionData.id
    statisticApiClient.browseCategoryEvent(data)
  }

  exitWithProductEvent (data: ExitWithProductEventData) {
    data = this.setSessionDataToExitEventData(data)
    statisticApiClient.exitWithProductEvent(data)
  }

  exitWithCategoryEvent (data: ExitWithCategoryEventData) {
    data = this.setSessionDataToExitEventData(data)
    statisticApiClient.exitWithCategoryEvent(data)
  }

  exitWithCloseEvent (data: ExitEventData) {
    data = this.setSessionDataToExitEventData(data)
    statisticApiClient.exitWithCloseEvent(data)
  }

  exitWithOldSearchEvent (data: ExitEventData) {
    data = this.setSessionDataToExitEventData(data)
    statisticApiClient.exitWithOldSearchEvent(data)
  }

  private setSessionDataToExitEventData (data: any) {
    data.sessionId = this.sessionData.id
    data.totalFound = this.sessionData.totalFound
    data.maxRelevance = this.sessionData.maxRelevance

    return data
  }
}
